import { render, staticRenderFns } from "./FilePond.vue?vue&type=template&id=03adad82&"
import script from "./FilePond.vue?vue&type=script&lang=js&"
export * from "./FilePond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports